import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-800 text-white py-6 mt-12">
      <div className="container mx-auto text-center space-y-2">
        <p>{t('contact.phoneLabel')} <a href="tel:+998933159939" className="underline">+998 93 315 99 39</a></p>
        <p>{t('contact.emailLabel')} <a href="mailto:icefroghs@gmail.com" className="underline">info@navoietm.uz</a></p>
        <p>{t('contact.addressLabel')} Navoiy sh., Me‘morlar ko‘chasi, 16 G uy</p>
        <p className="text-sm text-gray-400">© {new Date().getFullYear()} "Navoiy Kompyuter Spektr ETM". Barcha huquqlar himoyalangan.</p>
      </div>
    </footer>
  );
};

export default Footer;
